var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMegaphone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1024_2094)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.06866 9.86526C2.10506 9.68999 2.1617 9.52288 2.25069 9.368C2.51767 8.89927 2.97881 8.74846 3.49659 8.74846C4.95283 8.74846 6.41312 8.75254 7.86937 8.74438C8.03522 8.74438 8.07972 8.78107 8.07972 8.95226C8.07163 10.6927 8.07163 12.429 8.07972 14.1694C8.07972 14.3406 8.03522 14.3814 7.86937 14.3773C6.41312 14.3691 4.95283 14.3732 3.49659 14.3732C2.81296 14.3732 2.18192 13.9819 2.06461 13.2646C1.98775 12.7918 2.04439 12.27 2.04034 11.7932C2.02821 11.1736 1.94326 10.4807 2.06866 9.86526Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7636 4C17.9011 4 18.0386 4 18.1721 4C18.8436 4.12228 19.2562 4.63584 19.2562 5.3532C19.2562 8.45497 19.2562 11.5567 19.2562 14.6585C19.2562 15.7019 19.2562 16.7454 19.2562 17.7888C19.2562 18.8934 18.2611 19.4966 17.2822 18.9871C14.5517 17.5728 11.8213 16.1584 9.09079 14.7522C8.96539 14.687 8.9209 14.6177 8.9209 14.4792C8.92494 12.5431 8.92494 10.607 8.9209 8.67099C8.9209 8.53241 8.9573 8.45904 9.08675 8.39383C11.8455 6.97541 14.5962 5.56107 17.3469 4.14673C17.4804 4.07744 17.618 4.02038 17.7636 4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1178 11.5445C20.1178 11.1166 20.1219 10.6927 20.1138 10.2647C20.1138 10.1424 20.1421 10.1261 20.2473 10.1791C20.5749 10.3462 20.8095 10.5989 20.9107 10.9535C21.0239 11.357 21.0239 11.7728 20.9107 12.1763C20.8095 12.5309 20.5749 12.7836 20.2473 12.9507C20.138 13.0078 20.1138 12.9833 20.1138 12.8651C20.1219 12.4209 20.1178 11.9847 20.1178 11.5445Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.59121 15.2536C7.10899 15.2536 7.62677 15.2577 8.14454 15.2496C8.26185 15.2496 8.31848 15.2699 8.35489 15.3963C8.66232 16.509 8.98593 17.6136 9.28931 18.7263C9.52393 19.5863 8.95357 20.3893 8.06769 20.4463C7.75217 20.4667 7.43665 20.479 7.12113 20.4341C6.56694 20.3567 6.19075 20.0428 6.03703 19.5089C5.63656 18.1435 5.26037 16.7699 4.86799 15.4004C4.82754 15.2577 4.87608 15.2455 4.99743 15.2455C5.52735 15.2536 6.0613 15.2536 6.59121 15.2536Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1024_2094"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 16.4667,
    fill: "white",
    transform: "translate(2 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMegaphone);
export default __webpack_public_path__ + "static/media/megaphone.0171a3b777b800a610c82c32839b00c5.svg";
export { ForwardRef as ReactComponent };